import { styled } from "@mui/material";


export const SvgIconContainer = styled("div")({
    "svg": {
        height: "36px",
    }
});
